// PWA install + web-push helpers.

export function isIos() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return (
    /iphone|ipad|ipod/i.test(ua) ||
    // iPadOS reports as Mac but has touch
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  const mm = (q) => window.matchMedia && window.matchMedia(q).matches;
  return (
    mm('(display-mode: standalone)') ||
    mm('(display-mode: fullscreen)') ||
    mm('(display-mode: minimal-ui)') ||
    navigator.standalone === true ||
    (document.referrer || '').startsWith('android-app://')
  );
}

export function pushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

// Returns 'unsupported' | 'denied' | 'subscribed' | 'default'
export async function getPushState() {
  if (!pushSupported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return sub ? 'subscribed' : 'default';
}

export async function subscribeToPush(API, axios) {
  if (!pushSupported()) throw new Error('unsupported');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('denied');

  const { data } = await axios.get(`${API}/push/config`);
  if (!data.enabled || !data.public_key) throw new Error('server-disabled');

  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  const json = sub.toJSON();
  await axios.post(
    `${API}/push/subscribe`,
    { endpoint: json.endpoint, keys: json.keys },
    { withCredentials: true }
  );
  return true;
}

export async function unsubscribeFromPush(API, axios) {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) {
    const { endpoint } = sub;
    await sub.unsubscribe();
    try {
      await axios.post(
        `${API}/push/unsubscribe`,
        { endpoint, keys: {} },
        { withCredentials: true }
      );
    } catch (e) {
      /* best effort */
    }
  }
  return true;
}
